import { toast, ToastContainer } from "react-toastify";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { VariablesConstant } from "../../../../constants/variables";
import { Constant } from "../../../../constants/constant";
import { Dropdown } from "primereact/dropdown";
import { useDispatch } from "react-redux";
import { showAndHideSpinner } from "../../../../reducers/spinnerSlice";
import { Dcs0101Service } from "../../../../services/dcs/Dcs0101Service";
import ConnectionDetail from "../components/ConnectionDetail";
import { ExceptionConstant } from "../../../../constants/exceptionConstant";
import Swal from "sweetalert2";
import { Dcs0201Service } from "../../../../services/dcs/Dcs0201Service";
import { useAppSelector } from "../../../../store/hook";
import { ComStdService } from "../../../../services/common/ComStdService";
import FunctionButton from "../../../../components/layout/FunctionButton";
import Dcs0301Service from "../../../../services/dcs/Dcs0301Service";

export default function Dcs0101Form(props: any) {
  const { t, i18n } = useTranslation();

  const [isEdit, setIsEdit] = useState<any>(false);
  const [isClone, setIsClone] = useState<any>(props.data.isClone);
  const [isCreate, setIsCreate] = useState<any>(props.data.isCreate);

  const [model, setModel] = useState<any>({});
  const [dataCycle, setDataCycle] = useState<any>();
  // const status: any[] = VariablesConstant.CONNECTION_STATUS;
  const [dataMap, setDataMap] = useState<any>();

  const [protLst, setProtLst] = useState<any>();
  const [protSlt, setProtSlt] = useState<any>();
  const [connProtVerLst, setConnProtVerLst] = useState<any>();
  const [uaSecModesTcp, setUaSecModesTcp] = useState<any>();
  const [uaSecModesHttps, setUaSecModesHttps] = useState<any>();
  const [uaSecPolicies, setUaSecPolicies] = useState<any>();
  const [uaConnectTp, setUaConnectTp] = useState<any>();
  const [listDataMap, setListDataMap] = useState<any>();

  const [haveDataCycle, setHaveDataCycle] = useState<any>(false);
  const [haveSecModes, setHaveSecModes] = useState<any>(false);
  const [haveSecPolicies, setHaveSecPolicies] = useState<any>(false);

  const lang = useAppSelector((state: any) => state.language.lang);

  const dispatch = useDispatch();

  useEffect(() => {
    getProtLst();
    if (isCreate) {
      setModel({
        ...model,
      });
    } else {
      _getConnectionById(props.data.connId);
    }
  }, []);

  useEffect(() => {
    if (model.connProtTp && Object.keys(model.connProtTp).length > 0) {
      if (model.connProtTp.id === VariablesConstant.PROTOCOL_OPC_UA) {
        getUaConnectTpLst();
        getUaSecModesTcpLst();
        getUaSecModesHttpsLst();
        getUaSecPoliciesLst();
      }
    }
  }, [model.connProtTp]);

  useEffect(() => {
    if (dataCycle) {
      setModel({ ...model, dataCycle: dataCycle });
    }
  }, [dataCycle]);

  useEffect(() => {
    if (dataMap) {
      setModel({ ...model, dataMap: dataMap });
    }
  }, [dataMap]);

  const getUaConnectTpLst = () => {
    let req = { upCommCd: Constant.UA_CONNECT_TP };
    ComStdService.getInstance()
      .getListTccoStd(req)
      .then((res: any) => {
        setUaConnectTp(res.data.responseData);
      })
      .catch((err: any) => {});
  };

  // const getConnProtTpLst = () => {
  //   let req = { upCommCd: Constant.CONNECTION_PROTOCOL_TYPE };
  //   ComStdService.getInstance()
  //     .getListTccoStd(req)
  //     .then((res: any) => {
  //       setConnProtLst(res.data.responseData);
  //     })
  //     .catch((err: any) => {});
  // };

  const getProtLst = () => {
    Dcs0301Service.getInstance()
      .getList({})
      .then((res: any) => {
        setProtLst(res.data.responseData.data);
      })
      .catch((err: any) => {});
  };

  const getUaSecModesTcpLst = () => {
    let req = { upCommCd: Constant.SECURITY_MODES_TCP };
    ComStdService.getInstance()
      .getListTccoStd(req)
      .then((res: any) => {
        setUaSecModesTcp(res.data.responseData);
      })
      .catch((err: any) => {});
  };

  const getUaSecModesHttpsLst = () => {
    let req = { upCommCd: Constant.SECURITY_MODES_HTTPS };
    ComStdService.getInstance()
      .getListTccoStd(req)
      .then((res: any) => {
        setUaSecModesHttps(res.data.responseData);
      })
      .catch((err: any) => {});
  };

  const getUaSecPoliciesLst = () => {
    let req = { upCommCd: Constant.SECURITY_POLICIES };
    ComStdService.getInstance()
      .getListTccoStd(req)
      .then((res: any) => {
        setUaSecPolicies(res.data.responseData);
      })
      .catch((err: any) => {});
  };

  function _getConnectionById(connId: any) {
    dispatch(showAndHideSpinner(true));
    Dcs0101Service.getInstance()
      .getConnectionDetail({ connectionId: connId })
      .finally(() => {
        dispatch(showAndHideSpinner(false));
      })
      .then((res: any) => {
        setModel(res.data.responseData);
        getDataMapByConnType(res.data.responseData.connProtTp.id);
        // setProtSlt(res.data.responseData.protocol);
        setDataMap(res.data.responseData.dataMapping);
        setDataCycle(res.data.responseData.dataCycle);

        if (res.data.responseData.dataCycle && res.data.responseData.dataCycle != null) {
          setHaveDataCycle(true);
        }
        if (res.data.responseData.extraInfo.secModes) {
          setHaveSecModes(true);
        }
        if (res.data.responseData.extraInfo.secPolicies) {
          setHaveSecPolicies(true);
        }
      })
      .catch((err: any) => {});
  }

  const handleChange = (event: any) => {
    setModel({
      ...model,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeProtTp = (event: any) => {
    setProtSlt(event);
  };

  useEffect(() => {
    if (protSlt) {
      getLstProtVer();
    }
  }, [protSlt]);

  const getLstProtVer = () => {
    Dcs0301Service.getInstance()
      .getVersionByProtId({ protId: protSlt.id, status: VariablesConstant.ACTIVE_STATUS_VAL })
      .then((res: any) => {
        setConnProtVerLst(res.data.responseData.data);
      })
      .catch((err: any) => {});
  };

  const handleChangeProtVer = (event: any) => {
    setModel({
      ...model,
      connProtTp: event,
    });
  };

  const handleChangeConnectTp = (event: any) => {
    setModel({
      ...model,
      connectionType: event,
      extraInfo: {},
    });
  };

  const handleChangeDataMapping = (event: any) => {
    setModel({
      ...model,
      sltDataMap: event,
    });
  };

  // const onAddRow = () => {
  //   setDataMap((prevItem: any) => [...prevItem, {}]);
  // };

  // const onDeleteRow = (index: any) => {
  //   if (!props.data.isCreate) {
  //     if (model.dataMapDel) {
  //       setModel({ ...model, dataMapDel: [...model.dataMapDel, dataMap[index]] });
  //     } else {
  //       setModel({ ...model, dataMapDel: [...[], dataMap[index]] });
  //     }
  //   }
  //   setDataMap(dataMap.filter((item: any, idx: any) => idx !== index));
  // };

  // const handleChangeDataMap = (event: any, index: any) => {
  //   setDataMap(
  //     dataMap.map((item: any, idx: any) =>
  //       idx === index ? (!props.data.isCreate && item.id ? { ...item, [event.target.name]: event.target.value, isUpdate: true } : { ...item, [event.target.name]: event.target.value }) : item
  //     )
  //   );
  // };

  const handleSelectSecModes = (event: any) => {
    setModel({ ...model, extraInfo: { ...model.extraInfo, secModes: event.target.value } });
  };

  const handleSelectSecPolicies = (event: any) => {
    setModel({ ...model, extraInfo: { ...model.extraInfo, secPolicies: event.target.value } });
  };

  const onChangeHaveDataCycle = (event: any) => {
    setHaveDataCycle(event.target.checked);
    if (!event.target.checked) {
      setModel((prevModel: any) => {
        return {
          ...prevModel,
          dataCycle: undefined,
        };
      });
      setDataCycle(undefined);
    } else {
      setModel((prevModel: any) => {
        return {
          ...prevModel,
          dataCycle: "",
        };
      });
      setDataCycle("");
    }
  };

  const onChangeHaveSecModes = (event: any) => {
    setHaveSecModes(event.target.checked);
    if (!event.target.checked) {
      setModel((prevModel: any) => {
        const { secModes, ...restExtraInfo } = prevModel.extraInfo;
        return {
          ...prevModel,
          extraInfo: restExtraInfo,
        };
      });
    }
  };

  const onChangeHaveSecPolicies = (event: any) => {
    setHaveSecPolicies(event.target.checked);
    if (!event.target.checked) {
      setModel((prevModel: any) => {
        const { secPolicies, ...restExtraInfo } = prevModel.extraInfo;
        return {
          ...prevModel,
          extraInfo: restExtraInfo,
        };
      });
    }
  };

  const getDataMapByConnType = (connType: String) => {
    Dcs0201Service.getInstance()
      .getDataMapByConnType(connType)
      .then((res) => {
        if (res.data.status) {
          if (res.data.responseData && res.data.responseData.length > 0) {
            setListDataMap(res.data.responseData);
          } else {
            toast.warning("This connection protocol don't have data map");
          }
        }
      });
  };

  const handleSave = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (chk(model)) {
      if (isCreate) {
        _save();
      } else {
        if (isEdit) {
          _update();
        } else if (isClone) {
          _save();
        }
      }
    }
  };

  function _save() {
    dispatch(showAndHideSpinner(true));
    Dcs0101Service.getInstance()
      .insertConnection(model)
      .finally(() => {
        dispatch(showAndHideSpinner(false));
      })
      .then((res: any) => {
        if (res.data.status) {
          toast.success(`${t("dcs0101.message.success.save")}`);
          props.onClose(true);
        } else {
          if (res.data.message === ExceptionConstant.TABLE_NM_EXISTED) {
            toast.error(`${t("dcs0101.message.error.tableNmExisted")}`);
          } else {
            toast.error(`${t("dcs0101.message.error.save")}`);
          }
        }
      })
      .catch((err: any) => {
        toast.error(`${t("message.error.system")}`);
      });
  }

  const _update = () => {
    dispatch(showAndHideSpinner(true));
    Dcs0101Service.getInstance()
      .updateConnection(model)
      .finally(() => {
        dispatch(showAndHideSpinner(false));
      })
      .then((res: any) => {
        if (res.data.status) {
          toast.success(`${t("dcs0101.message.success.update")}`);
          props.onClose(true);
        } else {
          if (res.data.message === ExceptionConstant.TABLE_NM_EXISTED) {
            toast.error(`${t("dcs0101.message.error.tableNmExisted")}`);
          } else {
            toast.error(`${t("dcs0101.message.error.update")}`);
          }
        }
      })
      .catch((err: any) => {
        toast.error(`${t("dcs0101.message.error.system")}`);
      });
  };

  function chk(params: any) {
    let _chk = true;
    if (params.connNm == null || params.connNm.trim() === "") {
      toast.error(`${t("dcs0101.message.required.connNm")}`);
      _chk = false;
    } else if (params.connProtTp == null || Object.keys(params.connProtTp).length === 0) {
      toast.error(`${t("dcs0101.message.required.connProtTp")}`);
      _chk = false;
    } else if (params.sltDataMap == null || Object.keys(params.sltDataMap).length === 0) {
      toast.error(`${t("dcs0101.message.required.dataMap")}`);
      _chk = false;
    } else if (params.ip == null || params.ip.toString().trim() === "") {
      toast.error(`${t("dcs0101.message.required.ip")}`);
      _chk = false;
    } else if (params.port == null || params.port.toString().trim() === "") {
      toast.error(`${t("dcs0101.message.required.port")}`);
      _chk = false;
    } else if (params.kafkaTopic == null || params.kafkaTopic.toString().trim() === "") {
      toast.error(`${t("dcs0101.message.required.kafkaTopic")}`);
      _chk = false;
    } else if (params.tableNm == null || params.tableNm.toString().trim() === "") {
      toast.error(`${t("dcs0101.message.required.tableNm")}`);
    }

    if (params.connProtTp.id === VariablesConstant.PROTOCOL_MODBUS) {
      if (params.slaveId == null || params.slaveId.toString().trim() === "") {
        toast.error(`${t("dcs0101.message.required.slaveId")}`);
        _chk = false;
      } else if (params.dataOffset == null || params.dataOffset.toString().trim() === "") {
        toast.error(`${t("dcs0101.message.required.dataOffset")}`);
        _chk = false;
      } else if (params.quantity == null || params.quantity.toString().trim() === "") {
        toast.error(`${t("dcs0101.message.required.quantity")}`);
        _chk = false;
      }
    }

    if (params.connProtTp.id === VariablesConstant.PROTOCOL_MQTT) {
      if (params.clientId == null || params.clientId.toString().trim() === "") {
        toast.error(`${t("dcs0101.message.required.clientId")}`);
        _chk = false;
      } else if (params.topic == null || params.topic.toString().trim() === "") {
        toast.error(`${t("dcs0101.message.required.topic")}`);
        _chk = false;
      }
    }

    if (params.connProtTp.id === VariablesConstant.PROTOCOL_OPC_UA) {
      if (params.serverName == null || params.serverName.toString().trim() === "") {
        toast.error(`${t("dcs0101.message.required.serverName")}`);
        _chk = false;
      } else if (params.connectionType == null || Object.keys(params.connectionType).length === 0) {
        toast.error(`${t("dcs0101.message.required.connectionType")}`);
        _chk = false;
      }
    }

    if (!_chk) {
      setModel((prevState: any) => {
        return {
          ...prevState,
          connNm: prevState.connNm || "",
          connProtTp: prevState.connProtTp || {},
          sltDataMap: prevState.sltDataMap || {},
          ip: prevState.ip || "",
          port: prevState.port || "",
          username: prevState.username || "",
          pwd: prevState.pwd || "",
          kafkaTopic: prevState.kafkaTopic || "",
          dataCycle: prevState.dataCycle || "",
          tableNm: prevState.tableNm || "",
          slaveId: prevState.slaveId || null,
          dataOffset: prevState.dataOffset || null,
          quantity: prevState.quantity || null,
          clientId: prevState.clientId || "",
          topic: prevState.topic || "",
          serverName: prevState.serverName || "",
          connectionType: prevState.connectionType || {},
        };
      });
    }
    return _chk;
  }

  const handleAdd = () => {
    setIsCreate(true);
  };

  const handleClone = () => {
    setIsClone(true);
  };

  const handleEdit = () => {
    setProtSlt(protLst.find((ele: any) => ele.id === model.protocol.id));
    setIsEdit(true);
  };

  const handleBack = () => {
    setIsEdit(false);
  };

  const deleteItem = () => {
    if (model.status.commCd === VariablesConstant.CONNECTION_STATUS_RUNNING) {
      toast.error(`${t("dcs0101.message.error.connectionRunning")}`);
      return;
    }
    Swal.fire({
      title: `${t("confirm.label.title")}`,
      text: `${t("confirm.label.message.delete")}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#89B449",
      cancelButtonColor: "#E68A8C",
      confirmButtonText: `${t("confirm.button.yes.text")}`,
      cancelButtonText: `${t("confirm.button.no.text")}`,
    }).then((result: any) => {
      if (result.value) {
        _delete(model.id);
      }
    });
  };

  async function _delete(id: number) {
    try {
      dispatch(showAndHideSpinner(true));
      await Promise.all([Dcs0101Service.getInstance().deleteCollContainer({ connId: id }), Dcs0101Service.getInstance().deleteDelContainer({ connId: id })]);
      const res = await Dcs0101Service.getInstance().delete(id);
      if (res.data.status) {
        toast.success(`${t("dcs0101.message.success.delete")}`);
        props.onClose(true);
      }
    } catch (error) {
      toast.error(`${t("dcs0101.message.error.system")}`);
    } finally {
      dispatch(showAndHideSpinner(false));
    }
  }

  return (
    <>
      <ToastContainer></ToastContainer>
      {isEdit || isClone || isCreate ? (
        <>
          <div className="box" style={{ minHeight: "750px" }}>
            <div className="box-body">
              <form onSubmit={handleSave}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="col-lg-9">
                    <h3 className="header-title">{t("dcs0101.form.label.insertTitle")}</h3>
                  </div>
                  <div className="col-lg-3">
                    <div className="d-flex justify-content-end gap-2">
                      <button type="submit" className="custom-btn gradient">
                        <i className="pi pi-save fs-16 me-2"></i>
                        {t("confirm.button.save.text")}
                      </button>
                      {!isCreate && isEdit && (
                        <button type="button" className="custom-btn info" onClick={handleBack}>
                          <i className="pi pi-undo fs-16 me-2"></i>
                          {t("dialog.button.back.text")}
                        </button>
                      )}
                      <button type="button" onClick={() => props.onClose(false)} className="custom-btn">
                        <i className="pi pi-times fs-16 me-2"></i>
                        {t("dialog.button.cancel.text")}
                      </button>
                    </div>
                  </div>
                </div>

                <div className="form-container">
                  <div className="row align-items-center">
                    <div className="col-lg-2 form-label-grid">
                      <label htmlFor="validationInput" className="form-label">
                        {t("dcs0101.form.label.connectionNm")}
                        <strong className="strong-required"> *</strong>
                      </label>
                    </div>
                    <div className="col-lg-10">
                      <input
                        value={model.connNm || ""}
                        type="text"
                        className="form-control"
                        name="connNm"
                        id="validationInputConnNm"
                        onChange={handleChange}
                        placeholder={t("dcs0101.message.required.connNm")}
                      />
                      <div className={`${model.connNm?.trim() === "" ? "error-required" : "d-none"}`}>{t("dcs0101.message.required.connNm")}</div>
                    </div>
                  </div>

                  <div className="row align-items-center">
                    <div className="col-lg-2 form-label-grid">
                      <label htmlFor="validationInput" className="form-label">
                        {t("dcs0101.form.label.connectionProt")}
                        <strong className="strong-required"> *</strong>
                      </label>
                    </div>
                    <div className="col-lg-4">
                      <div className="d-flex gap-2">
                        <Dropdown
                          value={protSlt}
                          onChange={(e: any) => {
                            handleChangeProtTp(e.value);
                            // getDataMapByConnType(e.value.commCd);
                          }}
                          placeholder="-"
                          options={protLst}
                          optionLabel="protNm"
                          style={{ width: "100%" }}
                        />
                        <Dropdown
                          value={model.connProtTp}
                          onChange={(e: any) => {
                            handleChangeProtVer(e.value);
                            getDataMapByConnType(e.value.id);
                          }}
                          placeholder="-"
                          options={connProtVerLst}
                          optionLabel="ver"
                          style={{ width: "100%" }}
                        />
                      </div>
                      <div className={`${model.connProtTp && Object.keys(model.connProtTp).length === 0 ? "error-required" : "d-none"}`}>{t("dcs0101.message.required.connProtTp")}</div>
                    </div>
                    {listDataMap && (
                      <>
                        <div className="col-lg-2 form-label-grid border-left">
                          <label htmlFor="validationInputDataMap" className="form-label">
                            {t("dcs0101.form.label.dataMap")}
                            <strong className="strong-required"> *</strong>
                          </label>
                        </div>
                        <div className="col-lg-4">
                          <Dropdown
                            style={{ width: "100%" }}
                            value={model.sltDataMap}
                            filter={true}
                            onChange={(e) => handleChangeDataMapping(e.value)}
                            options={listDataMap}
                            optionLabel="dataMapName"
                            className="w-full md:w-14rem"
                            placeholder="-"
                          />
                          <div className={`${model.sltDataMap && Object.keys(model.connProtTp).length === 0 ? "error-required" : "d-none"}`}>{t("dcs0201.message.required.field")}</div>
                        </div>
                      </>
                    )}
                  </div>

                  <div className="row align-items-center">
                    <div className="col-lg-2 form-label-grid">
                      <label htmlFor="validationInput" className="form-label">
                        {t("dcs0101.form.label.ip")}
                        <strong className="strong-required"> *</strong>
                      </label>
                    </div>
                    <div className="col-lg-4">
                      <input value={model.ip || ""} type="text" className="form-control" name="ip" id="validationInputIp" onChange={handleChange} placeholder={t("dcs0101.message.required.ip")} />
                      <div className={`${model.ip?.toString().trim() === "" ? "error-required" : "d-none"}`}>{t("dcs0101.message.required.ip")}</div>
                    </div>
                    <div className="col-lg-2 form-label-grid border-left">
                      <label htmlFor="validationInput" className="form-label">
                        {t("dcs0101.table.header.port")}
                        <strong className="strong-required"> *</strong>
                      </label>
                    </div>
                    <div className="col-lg-4">
                      <input value={model.port} type="number" className="form-control" name="port" id="validationInputPort" onChange={handleChange} placeholder={t("dcs0101.message.required.port")} />
                      <div className={`${model.port?.toString().trim() === "" ? "error-required" : "d-none"}`}>{t("dcs0101.message.required.port")}</div>
                    </div>
                  </div>

                  {model.connProtTp && model.connProtTp.id === VariablesConstant.PROTOCOL_MODBUS && (
                    <>
                      <div className="row align-items-center">
                        <div className="col-lg-2 form-label-grid">
                          <label className="form-label">
                            {t("dcs0101.form.label.slaveId")}
                            <strong className="strong-required"> *</strong>
                          </label>
                        </div>
                        <div className="col-lg-4">
                          <input
                            value={model.slaveId}
                            type="number"
                            className="form-control"
                            name="slaveId"
                            id="validationInputSlaveId"
                            onChange={handleChange}
                            placeholder={t("dcs0101.message.required.slaveId")}
                          />
                          <div className={`${model.slaveId?.toString().trim() === "" ? "error-required" : "d-none"}`}>{t("dcs0101.message.required.slaveId")}</div>
                        </div>
                        <div className="col-lg-2 form-label-grid border-left">
                          <label className="form-label">
                            {t("dcs0101.form.label.offset")}
                            <strong className="strong-required"> *</strong>
                          </label>
                        </div>
                        <div className="col-lg-4">
                          <input
                            value={model.dataOffset}
                            type="number"
                            className="form-control"
                            name="dataOffset"
                            id="validationInputOffset"
                            onChange={handleChange}
                            placeholder={t("dcs0101.message.required.offset")}
                          />
                          <div className={`${model.dataOffset?.toString().trim() === "" ? "error-required" : "d-none"}`}>{t("dcs0101.message.required.offset")}</div>
                        </div>
                      </div>

                      <div className="row align-items-center">
                        <div className="col-lg-2 form-label-grid">
                          <label className="form-label">
                            {t("dcs0101.form.label.quantity")}
                            <strong className="strong-required"> *</strong>
                          </label>
                        </div>
                        <div className="col-lg-10">
                          <input
                            value={model.quantity}
                            type="number"
                            className="form-control"
                            name="quantity"
                            id="validationInputQuantity"
                            onChange={handleChange}
                            placeholder={t("dcs0101.message.required.quantity")}
                          />
                          <div className={`${model.quantity?.toString().trim() === "" ? "error-required" : "d-none"}`}>{t("dcs0101.message.required.quantity")}</div>
                        </div>
                      </div>
                    </>
                  )}

                  {model.connProtTp && model.connProtTp.id === VariablesConstant.PROTOCOL_MQTT && (
                    <>
                      <div className="row align-items-center">
                        <div className="col-lg-2 form-label-grid">
                          <label className="form-label">
                            {t("dcs0101.form.label.clientId")}
                            <strong className="strong-required"> *</strong>
                          </label>
                        </div>
                        <div className="col-lg-4">
                          <input
                            value={model.clientId || ""}
                            type="text"
                            className="form-control"
                            name="clientId"
                            id="validationInputClientId"
                            onChange={handleChange}
                            placeholder={t("dcs0101.message.required.clientId")}
                          />
                          <div className={`${model.clientId?.toString().trim() === "" ? "error-required" : "d-none"}`}>{t("dcs0101.message.required.clientId")}</div>
                        </div>
                        <div className="col-lg-2 form-label-grid border-left">
                          <label className="form-label">
                            {t("dcs0101.form.label.topic")}
                            <strong className="strong-required"> *</strong>
                          </label>
                        </div>
                        <div className="col-lg-4">
                          <input
                            value={model.topic || ""}
                            type="text"
                            className="form-control"
                            name="topic"
                            id="validationInputTopic"
                            onChange={handleChange}
                            placeholder={t("dcs0101.message.required.topic")}
                          />
                          <div className={`${model.topic?.toString().trim() === "" ? "error-required" : "d-none"}`}>{t("dcs0101.message.required.topic")}</div>
                        </div>
                      </div>
                    </>
                  )}

                  {model.connProtTp && model.connProtTp.id === VariablesConstant.PROTOCOL_OPC_UA && (
                    <>
                      <div className="row align-items-center">
                        <div className="col-lg-2 form-label-grid">
                          <label className="form-label">
                            {t("dcs0101.form.label.serverName")}
                            <strong className="strong-required"> *</strong>
                          </label>
                        </div>
                        <div className="col-lg-10">
                          <input
                            value={model.serverName || ""}
                            type="text"
                            className="form-control"
                            name="serverName"
                            id="validationInputServerNm"
                            onChange={handleChange}
                            placeholder={t("dcs0101.message.required.serverName")}
                          />
                          <div className={`${model.serverName?.toString().trim() === "" ? "error-required" : "d-none"}`}>{t("dcs0101.message.required.serverName")}</div>
                        </div>
                      </div>
                    </>
                  )}

                  <div className="row align-items-center">
                    <div className="col-lg-2 form-label-grid">
                      <label htmlFor="validationInput" className="form-label">
                        {t("dcs0101.form.label.username")}
                      </label>
                    </div>
                    <div className="col-lg-4">
                      <input
                        value={model.username || ""}
                        type="text"
                        className="form-control"
                        name="username"
                        id="validationInputUsername"
                        onChange={handleChange}
                        placeholder={t("dcs0101.message.required.username")}
                      />
                    </div>

                    <div className="col-lg-2 form-label-grid border-left">
                      <label htmlFor="validationInput" className="form-label">
                        {t("dcs0101.form.label.pwd")}
                      </label>
                    </div>
                    <div className="col-lg-4">
                      <input value={model.pwd || ""} type="text" className="form-control" name="pwd" id="validationInputPwd" onChange={handleChange} placeholder={t("dcs0101.message.required.pwd")} />
                    </div>
                  </div>

                  <div className="row align-items-center">
                    <div className="col-lg-2 form-label-grid">
                      <label className="form-label">
                        {t("dcs0101.form.label.kafkaTopic")}
                        <strong className="strong-required"> *</strong>
                      </label>
                    </div>
                    <div className="col-lg-4">
                      <input
                        value={model.kafkaTopic || ""}
                        type="text"
                        className="form-control"
                        name="kafkaTopic"
                        id="validationInputKafkaTopic"
                        onChange={handleChange}
                        placeholder={t("dcs0101.message.required.kafkaTopic")}
                      />
                      <div className={`${model.kafkaTopic?.toString().trim() === "" ? "error-required" : "d-none"}`}>{t("dcs0101.message.required.kafkaTopic")}</div>
                    </div>
                    <div className="col-lg-2 form-label-grid border-left">
                      <label className="form-label">
                        {t("dcs0101.form.label.tableNm")}
                        <strong className="strong-required"> *</strong>
                      </label>
                    </div>
                    <div className="col-lg-4">
                      <input
                        value={model.tableNm || ""}
                        type="text"
                        className="form-control"
                        name="tableNm"
                        id="validationInputTableNm"
                        onChange={handleChange}
                        placeholder={t("dcs0101.message.required.tableNm")}
                      />
                      <div className={`${model.tableNm?.toString().trim() === "" ? "error-required" : "d-none"}`}>{t("dcs0101.message.required.tableNm")}</div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-2 form-label-grid">
                      <label htmlFor="validationInput" className="form-label">
                        {t("dcs0101.form.label.dataCycle")}
                      </label>
                    </div>
                    <div className="col-lg-10 d-flex">
                      <div className="checkbox-radio">
                        <input type="checkbox" id="md_checkbox_hc" className="" checked={haveDataCycle} onChange={onChangeHaveDataCycle} />
                        <label htmlFor="md_checkbox_hc">{t("dcs0101.form.label.dataCycle")}</label>
                      </div>

                      {haveDataCycle && (
                        <div className="d-flex flex-wrap">
                          {VariablesConstant.CRON_EXPRESSION?.map((ele: any, index: any) => (
                            <div key={index} className="checkbox-radio">
                              <input type="radio" name="data-cycle" checked={dataCycle === ele.value} id={`data-cycle-${index}`} value={ele.value} onChange={() => setDataCycle(ele.value)} />
                              <label htmlFor={`data-cycle-${index}`}>{Constant.SOUTH_KOREA === lang ? ele.labelKr : ele.label}</label>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {model.connProtTp && model.connProtTp.id === VariablesConstant.PROTOCOL_OPC_UA && (
                  <div className="box-form mt-3">
                    <div className="row mb-3">
                      <div className="col-lg-2">
                        <label htmlFor="validationInputConnProtTp" className="form-label">
                          {t("dcs0101.form.label.connectionType")}
                          <strong className="strong-required"> *</strong>
                        </label>
                      </div>
                      <div className="col-lg-2">
                        <Dropdown
                          value={model.connectionType}
                          onChange={(e) => handleChangeConnectTp(e.value)}
                          options={uaConnectTp}
                          optionLabel={Constant.SOUTH_KOREA === lang ? Constant.COMM_NM_KR : Constant.COMM_NM_EN}
                          style={{ width: "100%" }}
                          placeholder="-"
                        />
                        <div className={`${model.connectionType && Object.keys(model.connectionType).length === 0 ? "error-required" : "d-none"}`}>{t("dcs0101.message.required.connectionType")}</div>
                      </div>
                    </div>
                    {model.connectionType && Object.keys(model.connectionType).length > 0 && (
                      <>
                        <div className="row">
                          <div className="dcs-checkbox d-flex align-items-center mb-3">
                            <div className="checkbox-radio">
                              <input type="checkbox" id="md_checkbox_sm" checked={haveSecModes} onChange={onChangeHaveSecModes} />
                              <label htmlFor="md_checkbox_sm">{t("dcs0101.form.label.securityModes")}</label>
                            </div>
                            {haveSecModes && (
                              <div className="row mb-3 bg-white rounded-4 py-3" style={{ width: "100%" }}>
                                {model.connectionType.commCd === VariablesConstant.UA_CONNECT_TP_TCP && (
                                  <div className="d-flex flex-wrap">
                                    {uaSecModesTcp?.map((ele: any, index: any) => (
                                      <div key={index} className="checkbox-radio">
                                        <input
                                          type="radio"
                                          name="sec-modes"
                                          checked={model.extraInfo.secModes === ele.commCd}
                                          id={`sec-modes-${index}`}
                                          value={ele.commCd}
                                          onChange={handleSelectSecModes}
                                        />
                                        <label htmlFor={`sec-modes-${index}`}>{Constant.SOUTH_KOREA === lang ? ele.commNm : ele.commNmEn}</label>
                                      </div>
                                    ))}
                                  </div>
                                )}
                                {model.connectionType.commCd === VariablesConstant.UA_CONNECT_TP_HTTPS && (
                                  <div className="d-flex flex-wrap">
                                    {uaSecModesHttps?.map((ele: any, index: any) => (
                                      <div key={index} className="checkbox-radio">
                                        <input
                                          type="radio"
                                          name="sec-modes"
                                          checked={model.extraInfo.secModes === ele.commCd}
                                          id={`sec-modes-${index}`}
                                          value={ele.commCd}
                                          onChange={handleSelectSecModes}
                                        />
                                        <label htmlFor={`sec-modes-${index}`}>{Constant.SOUTH_KOREA === lang ? ele.commNm : ele.commNmEn}</label>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                          <div className="dcs-checkbox d-flex align-items-center">
                            <div className="checkbox-radio">
                              <input type="checkbox" id="md_checkbox_sp" checked={haveSecPolicies} onChange={onChangeHaveSecPolicies} />
                              <label htmlFor="md_checkbox_sp">{t("dcs0101.form.label.securityPolicies")}</label>
                            </div>
                            {haveSecPolicies && (
                              <div className="row bg-white rounded-4 py-3" style={{ width: "100%" }}>
                                <div className="d-flex flex-wrap">
                                  {uaSecPolicies?.map((ele: any, index: any) => (
                                    <div key={index} className="checkbox-radio">
                                      <input
                                        type="radio"
                                        name="sec-policies"
                                        checked={model.extraInfo.secPolicies === ele.commCd}
                                        id={`sec-policies-${index}`}
                                        value={ele.commCd}
                                        onChange={handleSelectSecPolicies}
                                      />
                                      <label htmlFor={`sec-policies-${index}`}>{Constant.SOUTH_KOREA === lang ? ele.commNm : ele.commNmEn}</label>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                )}
                {/* {model.connProtTp && (
                  <DataMapInfo model={model} dataMap={dataMap} handleChange={handleChange} handleChangeDataMap={handleChangeDataMap} onAddRow={onAddRow} onDeleteRow={onDeleteRow} />
                )} */}
              </form>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="box" style={{ minHeight: "750px" }}>
            <div className="box-body">
              <div className="row">
                <div className="col-lg-6">
                  <h3 className="header-title">{t("dcs0101.title.dialog.detailConnection")}</h3>
                </div>
                <div className="col-lg-6 d-flex justify-content-end gap-2">
                  <button type="button" className="custom-btn btn-dark-blue" onClick={handleEdit}>
                    <i className="pi pi-pencil fs-16 me-2"></i>
                    {t("sample.label.button.edit")}
                  </button>

                  <button type="button" className="custom-btn danger" onClick={deleteItem}>
                    <i className="pi pi-trash fs-16 me-2"></i>
                    {t("sample.label.button.delete")}
                  </button>

                  <button type="button" onClick={() => props.onClose(false)} className="custom-btn">
                    <i className="pi pi-times fs-16 me-2"></i>
                    {t("dialog.button.cancel.text")}
                  </button>
                </div>
              </div>

              <ConnectionDetail model={model} dataMap={dataMap}></ConnectionDetail>

              <FunctionButton currView={VariablesConstant.VIEW_DETAILS_CONNECTION} onAdd={handleAdd} onClone={handleClone} onList={() => props.onClose(false)}></FunctionButton>
            </div>
          </div>
        </>
      )}
    </>
  );
}
